import { Link } from 'react-router'

/**
 * Halaman 404. Menyebut alamat yang tidak dikenal dan menawarkan jalan kembali
 * ke dashboard, bukan tautan ke halaman yang belum ada.
 */
export function NotFoundPage() {
  return (
    <div className="state">
      <p className="state__title">Alamat ini tidak ada di konsol</p>
      <p className="state__body">
        Tidak ada halaman yang cocok dengan alamat ini. Periksa kembali tautannya, atau
        mulai dari dashboard untuk melihat pekerjaan yang menunggu.
      </p>
      <div className="state__actions">
        <Link className="btn btn--primary" to="/">
          Buka dashboard
        </Link>
        <Link className="btn" to="/transactions">
          Cari transaksi
        </Link>
      </div>
    </div>
  )
}
